import { Link } from 'gatsby';
import Img from 'gatsby-image';
import marked from 'marked';
import React from 'react';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';

import { LocationProps } from '../interfaces/LocationProps';
import { crewImagesQuery } from '../queries/CrewImagesQuery';
import { encodeUri } from '../utils/EncodeUri';
import { findImage } from '../utils/FindImage';
import { linkUrl } from '../utils/LinkUrl';
import { removePolishSigns } from '../utils/RemovePolishSigns';
import { theme } from '../utils/Theme';
import { Section } from './Section';

const Container = styled.div`
  &:nth-last-child(1):nth-child(odd) {
    grid-column: auto / span 2;
  }
  ${theme.mediaQuerySizes.phone} {
    grid-column: 1;
  }
`;
const DataMembers = styled.div`
  text-align: center;
  p {
    font-family: 'Recoleta-Regular';
    font-weight: lighter;
  }
`;
const MemberName = styled.h3`
  font-family: 'Recoleta-Regular';
  font-weight: lighter;
  font-size: 28px;
  margin-bottom: 10px;
  color: ${theme.colors.black};

  :hover {
    color: ${theme.colors.green};
  }
`;
const MemberPosition = styled.h4`
  font-family: 'Recoleta-Regular';
  font-weight: lighter;
  font-size: 15px;
  color: ${theme.colors.darkGreen};
`;
const MemberImage = styled(Img)`
  border-radius: 50%;
  border: 10px solid white;
  width: 200px;
  margin: 0 auto;
  margin-bottom: 20px;
  box-shadow: 7px 7px 7px ${theme.colors.light};
  transition: all 0.4s ease-out;
  :hover {
    transform: rotate(5deg);
  }
`;
const Description = styled.div`
  font-family: 'Recoleta-Regular';

  h3 {
    font-family: 'Recoleta-Medium';
    color: ${theme.colors.green};
    text-align: center;
    margin-top: 50px;
  }
  blockquote {
    margin-bottom: 0;

    h4 {
      font-family: 'Recoleta-Regular';
      font-style: italic;
      text-align: center;
    }
  }
  h5 {
    text-align: center;
    font-weight: 400;
    font-variant: small-caps;
  }
`;

interface CrewProps {
  name: string;
  position: string;
  description?: string;
  image: string;
  location: LocationProps;
}

const CrewMember = (props: CrewProps) => {
  const data = crewImagesQuery();
  const link = linkUrl(props.location.pathname, 'o-nutce#' + encodeUri(removePolishSigns(props.name || '') || ''));
  return (
    <Container>
      <Section id={props.name} backgroundColor="transparent">
        <Link to={link}>
          <MemberImage fluid={findImage(props.image, data) || []} />
        </Link>
        <DataMembers>
          <Link to={link}>
            <MemberName>{props.name}</MemberName>
          </Link>
          <MemberPosition>{props.position}</MemberPosition>
          <Description
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(marked(props.description || '')),
            }}
          ></Description>
        </DataMembers>
      </Section>
    </Container>
  );
};

export default CrewMember;
